// 图像编辑相关翻译

export const editing = {
    // 图像编辑面板
    imageEditingPanel: '图像编辑面板',
    uploadImage: '上传图片',
    uploadImageDescription: '上传图片开始编辑',
    dragDropImage: '拖拽图片到此处，或点击选择',
    dragOrClickUpload: '拖拽图片到此处，或点击选择',
    supportedFormats: '支持格式：JPG、PNG、WebP',
    maxFileSize: '最大文件大小：10MB（剩余 {remaining} 个位置）',
    uploadedImages: '已上传图片（{count}）',
    fileRejectedError: '文件被拒绝。请检查格式和大小。',
    slotsRemainingError: '仅剩 {slots} 个位置',
    uploadImageFirst: '请先上传图片',
    
    // 编辑功能
    conversationalEditing: '对话式编辑',
    conversationalEditingDescription: '描述您想要进行的更改',
    conversationalEditingFeature: '自然语言编辑指令',
    multiImageReference: '多图片参考支持',
    intelligentUnderstanding: '智能理解编辑意图',
    
    // AI图像编辑
    aiImageEditing: 'AI图像编辑',
    quickStyles: '快速风格',
    quickStyleOptions: {
      enhancedetails: '增强细节',
      artstyle: '艺术风格',
      animestyle: '动漫风格', 
      realisticphoto: '真实照片'
    },
    describeEffect: '描述您想要的效果',
    describeEffectPlaceholder: '例如：让它看起来像油画，添加戏剧性光线，改为动漫风格...',
    
    // 样式提示
    stylePrompts: {
      enhanceDetails: '增强图像细节和锐度',
      artStyle: '转换为艺术风格',
      animeStyle: '转换为动漫/漫画风格',
      realisticPhoto: '让它看起来像真实照片'
    },
    
    // 编辑错误处理
    editingGeneralError: '图像编辑失败',
    editingRateLimitError: '编辑速率限制超出',
    editingInsufficientCreditsError: '编辑积分不足',
    editingNetworkError: '编辑过程中网络错误',
    imageEditingTimeout: '图像编辑超时',
    checkEditingStatusFailed: '检查编辑状态失败',
    
    // 编辑操作
    editingOptions: '编辑选项',
    styleTransfer: '风格转换',
    enhancement: '增强',
    filters: '滤镜',
    adjustments: '调整',
    
    // 样式转换
    selectStyle: '选择风格',
    applyStyle: '应用风格',
    styleStrength: '风格强度',
    preserveDetails: '保留细节',
    
    // 增强选项
    enhanceQuality: '品质增强',
    upscale: '放大',
    denoising: '降噪',
    sharpening: '锐化',
    
    // 滤镜
    vintage: '复古',
    blackWhite: '黑白',
    sepia: '棕褐色',
    vibrant: '鲜艳',
    cool: '冷色调',
    warm: '暖色调',
    
    // 调整
    brightness: '亮度',
    contrast: '对比度',
    saturation: '饱和度',
    hue: '色调',
    
    // 操作按钮
    reset: '重置',
    apply: '应用',
    save: '保存',
    processing: '处理中...',
    
    // 错误和状态
    uploadError: '上传失败，请重试',
    processingError: '处理失败，请重试',
    imageProcessed: '图片处理成功',
    
    // 图像到图像
    imageToImageGeneration: '图像到图像生成',
    referenceImage: '参考图片',
    generationPrompt: '生成提示词',
    strength: '强度',
    strengthDescription: 'AI修改原始图像的程度',
    
    // 文本到图像面板
    textToImagePanel: '文字转图像面板',
    generateFromText: '从文字生成',
    textPrompt: '文字提示词',
    negativePrompt: '负面提示词',
    negativePromptPlaceholder: '您不希望在图像中看到的内容...',
    
    // 高级设置
    advancedSettings: '高级设置',
    seed: '种子',
    steps: '步数',
    guidanceScale: '引导比例',
    sampler: '采样器'
  };
